/* eslint-disable react/prop-types */
import React from 'react';
import ProductsBase from './Products';

export const Products = ({
  store,
  products,
  newLocalProducts,
  isLoading,
  mutateProducts,
  productsAreReordering,
}) => (
  <ProductsBase
    currency={store.currency}
    commissionLow={Number(store.commissionLow)}
    commissionHigh={Number(store.commissionHigh)}
    commissionCutoff={Number(store.commissionCutoff)}
    storeId={store.id}
    ggProductsData={products}
    ggProductsIsLoading={isLoading}
    newLocalProducts={newLocalProducts}
    mutateProducts={mutateProducts}
    productsAreReordering={productsAreReordering}
  />
);
